import { render, staticRenderFns } from "./customFile.vue?vue&type=template&id=424940f4&"
import script from "./customFile.vue?vue&type=script&lang=js&"
export * from "./customFile.vue?vue&type=script&lang=js&"
import style0 from "./customFile.vue?vue&type=style&index=0&id=424940f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports